import { render, staticRenderFns } from "./BankDetail.vue?vue&type=template&id=e6971db2"
import script from "./BankDetail.vue?vue&type=script&lang=js"
export * from "./BankDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme2ComponentsBankCryptoAddEmptyCard: require('/app/components/Theme2/Components/BankCryptoAddEmptyCard.vue').default,Theme2DesktopProfilesBankAccountCard: require('/app/components/Theme2/Desktop/Profiles/BankAccountCard.vue').default,Theme2DesktopProfilesCryptoWalletCard: require('/app/components/Theme2/Desktop/Profiles/CryptoWalletCard.vue').default,Theme2DesktopProfilesAddBankAccount: require('/app/components/Theme2/Desktop/Profiles/AddBankAccount.vue').default})
